<template>
  <form class="my-form">
    <slot></slot>
  </form>
</template>
<script>
export default {
  name: 'my-form',
  props: {
    // 一会考虑如何使用
    labelWidth: {
      type: String,
      default: '100px'
    }
  },
  // 传递数据给子子孙孙 对象写法 无法获取组件的值
  // provide: {
  //   labelWidth: this.labelWidth
  // }
  // 函数+返回值写法 可以获取到 Vue实例
  provide () {
    return {
      // 传递给后代时 改个名字 避免冲突
      formlabelWidth: this.labelWidth
    }
  }
}
</script>
